import React, { PropTypes } from 'react';
import cx from 'classnames'

class Input extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    validate: PropTypes.arrayOf(PropTypes.string),
    errorClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    errorContainerClassName: PropTypes.string
  };

  static contextTypes = {
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
  };

  static defaultProps = {
    containerClassName: 'form-group',
    errorContainerClassName: 'form-group-warning',
  };

  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    }

    this.onChange = this.onChange.bind(this)
    this.invalidate = this.invalidate.bind(this)
    this.validate = this.validate.bind(this)
  }

  componentWillMount() {
    this.context.subscribe(this)
  }

  componentWillUnmount() {
    this.context.subscribe(this)
  }

  validate() {
    this.context.validate(this.props.name)
  }

  onChange(e) {
    this.validate()

    if (this.props.onChange) {
      this.props.onChange(e)
    }
  }

  invalidate(hint) {
    this.setState({
      isValid: false,
      hint
    })
  }

  get value() {
    return this.refs.input.value
  }

  render() {
    const {
      // eslint-disable-next-line
      validate,
      containerClassName,
      errorClassName,
      errorContainerClassName,
      className,
      ...props
    } = this.props
    const { hint, isValid } = this.state

    return (
      <div className={cx(containerClassName, { [errorContainerClassName]: !isValid })}>
        <input
          {...props}
          ref="input"
          onChange={this.onChange}
          className={cx(className, {[errorClassName]: !isValid })}
        />
        { !isValid ? hint : null }
      </div>
    );
  }
}

export default Input;



/** WEBPACK FOOTER **
 ** ./src/components/base/Form/Input.js
 **/